import React from 'react';
import PageTransition from '../components/PageTransition';
import CarListings from '../components/CarListings';

const Fahrzeuge: React.FC = () => (
  <PageTransition>
    <CarListings />
  </PageTransition>
);

export default Fahrzeuge;
